import { Component, OnInit, Input } from '@angular/core';
import { BillingFormComponent } from 'ngx-intellforce-billing/lib/components/billing-form/billing-form.component';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss']
})
export class PrivacyComponent implements OnInit {

  @Input() form!: BillingFormComponent;
  constructor() { }

  ngOnInit() {
  }

}
